var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"download-page"},[_c('client-card',{attrs:{"mt4-card-info":_vm.mt4CardInfo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }